/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Account level ViewRIDs
 * @export
 * @interface ConfigurationViews
 */
export interface ConfigurationViews {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ConfigurationViews
	 */
	singleClientViewRID?: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ConfigurationViews
	 */
	listClientsViewRID?: string;
}

/**
 * Check if a given object implements the ConfigurationViews interface.
 */
export function instanceOfConfigurationViews(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function ConfigurationViewsFromJSON(json: any): ConfigurationViews {
	return ConfigurationViewsFromJSONTyped(json, false);
}

export function ConfigurationViewsFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ConfigurationViews {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		singleClientViewRID: !exists(json, 'SingleClientViewRID')
			? undefined
			: json['SingleClientViewRID'],
		listClientsViewRID: !exists(json, 'ListClientsViewRID')
			? undefined
			: json['ListClientsViewRID'],
	};
}

export function ConfigurationViewsToJSON(value?: ConfigurationViews | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		SingleClientViewRID: value.singleClientViewRID,
		ListClientsViewRID: value.listClientsViewRID,
	};
}
